/**
 * Script review, before it knows who is asking.
 *
 * Its own file because two things draw it: the page, while it resolves the
 * portal link, and `PortalSkeleton`, while the gate resolves the session.
 *
 * MEASURED OFF THE REAL SCREEN, not sketched to look like it. Every number
 * here was read from the rendered page: the title's 31 points and 167 of
 * width, the lede's 26, the composer's 200, the quota pill's 26 by 149, the
 * 8 between title and lede and the 24 either side of the box. A skeleton
 * whose blocks land where the content will not is a worse loading state than
 * a spinner, because it promises a layout and then moves it.
 *
 * Centred and vertically middled, because that is what this page is. The
 * previous loading state for this route was Home's bento grid, which told
 * everyone arriving at a one-field page to expect a wall of cards.
 */

"use client";

import { useTranslations } from "next-intl";
import { Skeleton } from "@/components/ui/design-system/skeleton";

export function ScriptReviewSkeleton() {
  const t = useTranslations("script");
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-nf-ds-block">
      {/* Not `<output>`, see the note in `HomeSkeleton`. */}
      <span className="sr-only">{t("loading")}</span>

      {/* `w-full max-w-3xl` on the wrapper, not `w-fit`: a percentage width
          inside a shrink-to-fit column resolves against the widest sibling,
          so the lede measured itself against the 167-point title and came out
          167 instead of 381. */}
      <div className="flex w-full max-w-3xl flex-col items-center gap-nf-ds-2">
        <Skeleton className="h-[31px] w-[167px]" />
        <Skeleton className="h-[26px] w-full max-w-[381px]" />
      </div>

      {/* The composer. One block rather than an outline with a fake button
          inside it: the box is a single surface in the real UI too, and a
          skeleton that draws controls is drawing things that cannot be
          pressed. */}
      <Skeleton className="h-[200px] w-full max-w-3xl rounded-nf-ds-card" />

      <Skeleton className="h-[26px] w-[149px] rounded-nf-ds-pill" />
    </div>
  );
}
